import { getPasskeyAuthenticatorName } from '@newcore/ui/passkey';

// Mirrors shared.constants.webauthn's rejection reasons, which enrollment
// returns as error_code on a 200 with success=false.
export const WebAuthnRejectionCode = {
  AAGUID_NOT_ALLOWED: 'aaguid_not_allowed',
  AAGUID_UNIDENTIFIED: 'aaguid_unidentified',
  ATTESTATION_UNTRUSTED: 'attestation_untrusted',
} as const;

const AAGUID_PREFIX_LENGTH = 8;

function describeModel(aaguid: string | null | undefined) {
  if (!aaguid) {
    return 'This security key';
  }

  // The bundled catalogue is a 2025 snapshot, so a new model resolves to
  // nothing; its raw AAGUID still tells support which model was refused.
  const name = getPasskeyAuthenticatorName(aaguid);

  return name ?? `This model (${aaguid.slice(0, AAGUID_PREFIX_LENGTH)}…)`;
}

/**
 * Copy for a registration your organization's policy refused.
 *
 * Returns null for anything else, including a generic failure with no code,
 * so callers keep their existing message rather than inventing a reason.
 */
export function webAuthnRejectionMessage(
  errorCode: string | null | undefined,
  aaguid: string | null | undefined
) {
  switch (errorCode) {
    case WebAuthnRejectionCode.AAGUID_NOT_ALLOWED:
      return `${describeModel(aaguid)} is not allowed by your organization. Try a different security key or passkey.`;
    case WebAuthnRejectionCode.AAGUID_UNIDENTIFIED:
      return "This authenticator did not identify its model, which your organization does not allow. If your browser asked whether to share the security key's make and model, choose to allow it and try again.";
    case WebAuthnRejectionCode.ATTESTATION_UNTRUSTED:
      return `${describeModel(aaguid)} could not prove it is genuine, so your organization will not accept it. Try a different security key or passkey.`;
    default:
      return null;
  }
}
